import { jsxs as p, Fragment as P, jsx as f } from "react/jsx-runtime";
import { useMemo as N, useRef as T, useState as c, useEffect as b } from "react";
import { getTabsStyles as W } from "./tools.js";
import { TabButton as $ } from "./TabButton.js";
import { TabsPopoverMenu as V } from "./TabsPopoverMenu.js";
const A = ({
  onChange: g,
  options: s,
  value: i,
  width: d = "fill",
  ...o
}) => {
  const j = { ...o, width: d }, x = N(() => Math.random().toString(), []), { wrapper: L } = W(j), m = "withGradients" in o ? o.withGradients : !1, n = T(null), [M, a] = c(!1), [G, l] = c(!1), u = () => {
    if (!n.current)
      return;
    const e = n.current.scrollLeft, { scrollWidth: t, clientWidth: r } = n.current;
    if (t === r) {
      a(!1), l(!1);
      return;
    }
    if (e <= 0) {
      l(!0), a(!1);
      return;
    }
    if (e + r >= t) {
      l(!1), a(!0);
      return;
    }
    a(!0), l(!0);
  };
  b(() => {
    if (!m || !n.current)
      return;
    u();
    const e = n.current;
    return e.addEventListener("scroll", u), () => {
      e.removeEventListener("scroll", u);
    };
  }, [m]);
  const h = "withPopoverMenu" in o ? o.withPopoverMenu : !1, [R, v] = c(!1), w = () => {
    if (!n.current)
      return;
    const { scrollWidth: e, clientWidth: t } = n.current;
    if (e > t) {
      v(!0);
      return;
    }
    v(!1);
  };
  b(() => {
    if (d === "fill" || !h) {
      v(!1);
      return;
    }
    return w(), window.addEventListener("resize", w), () => {
      window.removeEventListener("resize", w);
    };
  }, [d, h]);
  const [z, y] = c(!1), [H, I] = c(!1), O = (e) => {
    const t = s.findIndex(
      (r) => r.value === (i == null ? void 0 : i.value)
    );
    if (e < t) {
      I(!0);
      return;
    }
    y(!0);
  }, S = () => {
    I(!1), y(!1);
  }, E = (e) => {
    if (g(e), !m)
      return;
    const t = s.findIndex(
      ({ value: r }) => r === (e == null ? void 0 : e.value)
    );
    if (t === 0) {
      a(!1);
      return;
    }
    if (t === s.length - 1) {
      l(!1);
      return;
    }
    u();
  };
  return /* @__PURE__ */ p("div", { className: "jm-relative jm-w-[calc(100vw-32px)] sm:jm-w-full", children: [
    m && /* @__PURE__ */ p(P, { children: [
      /* @__PURE__ */ f(
        "div",
        {
          className: `jm-custom-tabs-left-gradient jm-pointer-events-none jm-absolute jm-inset-y-0 jm-left-0 jm-z-[3] jm-w-11 jm-rounded-l-3xl jm-transition-opacity jm-duration-300 jm-ease-in-out ${M ? "jm-opacity-100" : "jm-opacity-0"}`
        }
      ),
      /* @__PURE__ */ f(
        "div",
        {
          className: `jm-custom-tabs-right-gradient jm-pointer-events-none jm-absolute jm-inset-y-0 ${h ? "jm-right-9" : "jm-right-0 jm-rounded-r-3xl"} jm-z-[3] jm-w-11 jm-transition-opacity jm-duration-300 jm-ease-in-out ${G ? "jm-opacity-100" : "jm-opacity-0"}`
        }
      )
    ] }),
    /* @__PURE__ */ p("div", { ref: n, className: L(), children: [
      s.map((e, t) => /* @__PURE__ */ f(
        $,
        {
          tab: e,
          value: i,
          index: t,
          layoutId: x,
          onChange: E,
          handleResetIsHover: S,
          handleSetIsHover: O,
          isHoverOnLeft: z,
          isHoverOnRight: H,
          ...j
        },
        t
      )),
      R && /* @__PURE__ */ f(
        V,
        {
          options: s,
          value: i,
          onChange: g,
          size: j.size
        }
      )
    ] })
  ] });
};
export {
  A as Tabs
};
//# sourceMappingURL=index.js.map
